import { useState } from 'react';
import { StatBars } from './StatBars';
import { ActionButtons } from './ActionButtons';
import { ActionFeedback } from './ActionFeedback';
import { MemorialModal } from './MemorialModal';
import { BreedingModal } from './BreedingModal';
import { LineageModal } from './LineageModal';
import { MiniGameOverlay } from './MiniGameOverlay';
import { TopBar } from '@/presentation/topbar/TopBar';
import { SettingsModal } from '@/presentation/modals/SettingsModal';
import { BestiaryModal } from '@/presentation/modals/BestiaryModal';
import { GoToWorldButton } from '@/presentation/house/GoToWorldButton';
import { CareProfileModal } from './CareProfileModal';
import { TestLabModal } from '@/presentation/dev/TestLabModal';

export function HouseHud() {
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [bestiaryOpen, setBestiaryOpen] = useState(false);
  const [breedingOpen, setBreedingOpen] = useState(false);
  const [lineageOpen, setLineageOpen] = useState(false);
  const [miniGameOpen, setMiniGameOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const [debugOpen, setDebugOpen] = useState(false);

  return (
    <>
      <TopBar
        onOpenSettings={() => setSettingsOpen(true)}
        onOpenBestiary={() => setBestiaryOpen(true)}
        onOpenBreeding={() => setBreedingOpen(true)}
        onOpenLineage={() => setLineageOpen(true)}
        onOpenProfile={() => setProfileOpen(true)}
        onOpenDebug={() => setDebugOpen(true)}
      />
      <StatBars />
      <ActionButtons onOpenMiniGame={() => setMiniGameOpen(true)} />
      <ActionFeedback />
      <GoToWorldButton />
      <MemorialModal />
      <SettingsModal open={settingsOpen} onClose={() => setSettingsOpen(false)} />
      <BestiaryModal open={bestiaryOpen} onClose={() => setBestiaryOpen(false)} />
      <BreedingModal open={breedingOpen} onClose={() => setBreedingOpen(false)} />
      <LineageModal open={lineageOpen} onClose={() => setLineageOpen(false)} />
      <MiniGameOverlay open={miniGameOpen} onClose={() => setMiniGameOpen(false)} />
      <CareProfileModal open={profileOpen} onClose={() => setProfileOpen(false)} />
      {import.meta.env.DEV && <TestLabModal open={debugOpen} onClose={() => setDebugOpen(false)} />}
    </>
  );
}
